import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setcreateAssignStatus, setloading, seterror, resetcreateAssignStatus
} from "../reducers/createAssignmentStatusReducer";

const createAssignmentStatus = (data: any, token: any, courseType: any) => async (dispatch: Dispatch) => {
    dispatch(setloading(true));
    try {
        const endpoint =
            courseType === 1
                ? `/assignments/create-assignment-status/`
                : `/competitive/assignments/create-assignment-status/`;

        const result = await api
            .post(
                endpoint,
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Token ${token}`
                    },
                }
            )

        if (result) {
            dispatch(setloading(false));
            if (result.data?.status === 200) {
                dispatch(setcreateAssignStatus(true));
            }
            else {
                dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
            }
        }
    }
    catch (error: any) {
        dispatch(seterror(error.response.data.message));
    }
}

export { createAssignmentStatus, resetcreateAssignStatus }